export default __webpack_public_path__ + "static/media/banner_1.e9198ad6.png";